import { useQuery } from 'react-query';
import { getTenantIDBasedOnURL } from 'global/tenant-config';
import { getLaundryBookings } from './api';
import { mapDataForClient } from './mapData';

export const LAUNDRY_BOOKINGS = 'laundryBookings';

export function useLaundryBookings(resourceId) {
  const tenantId = getTenantIDBasedOnURL();

  const { data, isLoading, isFetching, isError } = useQuery(
    [LAUNDRY_BOOKINGS, tenantId, resourceId],
    () => getLaundryBookings(resourceId),
  );

  return {
    laundryBookings:
      data?.bookings
        ?.map((booking) => mapDataForClient(booking))
        ?.sort((a, b) => a?.fullDate - b?.fullDate) || [],
    isLoading,
    isFetching,
    isError,
  };
}
